import { FormControl, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../pages/Vehicles/Vehicles.css";
import StaffImg from "../../assets/svg/defultImage.svg";
import axios from "axios";
import {
  JOBS_TITLE,
  VEHICLE_ASSIGNS,
} from "../../URLs/Apis";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import $ from "jquery";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

const AssignStuffForm = ({ getStuffVehicle, handleClose, getVehicleById }) => {

  const { user } = useSelector((state) => state.auth);
  const TOKEN = "Bearer " + user?.token;
  const [jobsTitle, setjobsTitle] = useState([]);
  const [stuffs, setStuffs] = useState([]);

  const [jobTitleId, setJobTitleId] = useState(null);

  const [selectedStaff, setSelectedStaff] = useState([]);
  const [sortOrder, setSortOrder] = useState("");
  const { id: vanId } = useParams();

  const getJobsTitle = async () => {
    try {
      const response = await axios.get(`${JOBS_TITLE}`, {
        headers: { Authorization: TOKEN },
      });
      console.log(response);
      setjobsTitle(response.data.data.job_titles);
    } catch (error) {
      console.log(error);
    }
  };

  const JobTitleChange = async (id) => {
    setJobTitleId(id)
  };

  const getAvailableStaff = async () => {
    try {
      const response = await axios.get(
        `${VEHICLE_ASSIGNS}/${vanId}/available-staff${jobTitleId ? `?job_title_id=${jobTitleId}` : ""}`,
        {
          headers: { Authorization: TOKEN },
        }
      );
      let staffList = response.data.data.staff;

      staffList = sortStaff(staffList, sortOrder);

      setStuffs(staffList);

    } catch (error) {
      console.log(error);
    }
  }

  const handleAssignToVan = async (e) => {
    e.preventDefault();

    if (!jobTitleId) {
      toast.error("من فضلك اختر Job Title أولاً");
      return;
    }

    try {
      const formData = new FormData();
      selectedStaff.forEach((staff, index) => {
        formData.append(`assignments[${index}][stuff_id]`, staff.id);

        formData.append(`assignments[${index}][job_title_id]`, jobTitleId);
      });

      const response = await axios.post(
        `${VEHICLE_ASSIGNS}/${vanId}/staffs/bulk-assign`,
        formData,
        {
          headers: {
            Authorization: TOKEN,
          },
        },
      );

      // toast.success(response.data?.message);
      response.data?.data?.data?.successful?.forEach((success) => {
        toast.success(success.message);
      });
      setJobTitleId(null);
      setSelectedStaff([]);
      handleClose();
      getStuffVehicle();
      getVehicleById();
    } catch (error) {
      console.log("error", error);

      error.response.data?.errors?.data?.successful?.forEach((success) => {
        toast.success(success.message);
      });

      error.response.data?.errors?.data?.failed?.forEach((fail) => {
        toast.error(fail.message);
      });

      setJobTitleId(null);
      setSelectedStaff([]);
      handleClose();
      getStuffVehicle();
    }
  };
  
  const removeStaff = (staffId) => {
    setSelectedStaff((prev) =>
      prev.filter((s) => s.id !== staffId)
    );

    $(`#staff-${staffId}`).removeClass("selectedStaff");
  };

  const handleStaffSelection = (staff) => {
    if (window.innerWidth >= 1000) return;

    const isAlreadySelected = selectedStaff.some(
      (s) => s.id == staff.id
    );

    if (isAlreadySelected) {
      setSelectedStaff((prev) =>
        prev.filter((s) => s.id !== staff.id)
      );

      $(`#staff-${staff.id}`).removeClass("selectedStaff");
    } else {
      setSelectedStaff((prev) => [
        ...prev,
        {
          ...staff,
          job_title_id: staff.job_titles?.[0]?.id || null,
        },
      ]);

      $(`#staff-${staff.id}`).addClass("selectedStaff");
    }
  };

  const handleStaffChecked = (checked, staff) => {
    if (checked) {
      setSelectedStaff((prev) => [
        ...prev,
        {
          ...staff,
          job_title_id: staff.job_titles?.[0]?.id || null,
        },
      ]);
    } else {
      setSelectedStaff((prev) =>
        prev.filter((s) => s.id !== staff.id)
      );
    }
  };

  const sortStaff = (data, order) => {
    if (!order) return data;

    return [...data].sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      return order == "A to Z"
        ? nameA.localeCompare(nameB)
        : nameB.localeCompare(nameA);
    });
  };

  useEffect(() => {
    setStuffs((prev) => sortStaff(prev, sortOrder));
  }, [sortOrder]);

  useEffect(() => {
    getJobsTitle();
  }, []);

  useEffect(() => {
    getAvailableStaff();
  }, [jobTitleId])

  return (
    <form onSubmit={handleAssignToVan} className="m-1">
      <div>
        <div className="d-flex align-items-center gap-2">
          <div className="w-75">
            <label className="d-block text-black my-2">Job Title</label>
            <FormControl className="w-100">
              <Select
                size="small"
                MenuProps={{
                  PaperProps: {
                    style: { maxHeight: 200, overflowY: "scroll" },
                  },
                }}
                onChange={(e) => JobTitleChange(e.target.value)}
                displayEmpty
              >
                {jobsTitle.map((option) => (
                  <MenuItem
                    className="custom-menu-item"
                    key={option.id}
                    value={option.id}
                  >
                    <div>{option.title}</div>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="w-25">
            <label className="d-block text-black my-2">Sort by</label>
            <FormControl className="w-100">
              <Select
                size="small"
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
                displayEmpty
              >
                {["A to Z", "Z to A"].map((status) => (
                  <MenuItem
                    className="custom-menu-item"
                    key={status}
                    value={status}
                  >
                    <div className="label-size m-0">{status}</div>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        {selectedStaff.length > 0 && (
          <div className="mb-3 p-2">
            <div className="d-flex flex-wrap gap-2">
              {selectedStaff.map((staff) => (
                <div
                  key={staff.id}
                  style={{ backgroundColor: "#D8D8D8" }}
                  className="d-flex align-items-center px-2 py-1 border rounded-4 gap-1"
                >
                  <img style={{ width: "20px" }} src={StaffImg} alt="" />
                  <span className="">{staff.name}</span>
                  <div className="cursor" onClick={() => removeStaff(staff.id)}>
                    <RemoveCircleIcon
                      sx={{ marginInline: "", color: "#A80101" }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="equipment-scroll-container">
        <div className="row d-none d-lg-flex fw-bold">
          <div className="col-6">Name</div>
          <div className="col-6">Info</div>
        </div>
        {stuffs.length > 0 ? (
          stuffs.map((staff) => {
            const jobTitle = staff.job_titles?.[0].title || "No Job Title";
            const jobDiscription = staff.job_titles?.[0].description;
            const availableStaff = staff.available;
            return (
              availableStaff && (
                <div
                  id={`staff-${staff.id}`}
                  className="row staff-row align-items-center border-bottom cursor p-2 "
                  key={staff.id}
                  onClick={() => handleStaffSelection(staff)}
                >
                  <div className="col-12 col-lg-6 d-flex align-items-center gap-2 ">
                    <input
                      type="checkbox"
                      className="d-none d-lg-block"
                      checked={selectedStaff.some((s) => s.id == staff.id)}
                      onChange={(e) =>
                        handleStaffChecked(e.target.checked, staff)
                      }
                    />
                    <img
                      style={{ width: "50px" }}
                      src={StaffImg}
                      alt=""
                      className="d-none d-lg-block"
                    />
                    <div>
                      <span className="d-lg-none fw-bold me-2">Name:</span>
                      <h6 className="m-0 d-inline">{staff.name}</h6>
                      <p className="main-text-color m-0">{jobTitle}</p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <span className="d-lg-none fw-bold">Info:</span>
                    <div>
                      <p className="my-0">{jobDiscription}</p>
                      <p className="main-text-color m-0">
                        {staff.info?.can_drive ? "Can Drive" : "Can't Drive"}
                      </p>
                    </div>
                  </div>
                </div>
              )
            );
          })
        ) : (
          <div>No Available staff to assign!</div>
        )}
      </div>
      <div className="d-flex gap-3 justify-content-center align-items-center my-3 input-group-responsive fixed-footer">
        <button className="btn btn-dark px-5" disabled={!jobTitleId}>
          Save
        </button>
        <button
          type="reset"
          onClick={handleClose}
          className="btn btn-light px-5"
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AssignStuffForm;
